import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { useLocation } from "react-router-dom";
import { Container } from "reactstrap";
export default function TransactionGold() {
  const { hash } = useLocation();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable
            name="Appointment"
            disableAdd
            title="Hẹn nhận vàng, bán vàng"
            filter={{
              field: "paymentMethod",
              defaultValue: hash?.slice(1).toUpperCase() || "",
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
